const convertToTime = (timeInMinutes) => {
    const hourInMinutes = 60;
    const hours = Math.floor(timeInMinutes / hourInMinutes);
    const restMinutes = timeInMinutes % hourInMinutes;
    const minutes = restMinutes > 9 ? restMinutes : `0${restMinutes}`
    const seconds = '00';
    return [hours, minutes, seconds].join(':');
};

export {
    convertToTime
}